import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import ListButton from './ListButton';
import QuestionButton from './QuestionButton';
import { __ } from 'i18n-for-browser';
import BudgetSlider from './StepThree/BudgetSlider';
import BudgetCollaboration from './StepThree/BudgetCollaboration';
import FeedbackImage from './feedback/FeedbackImage';
import FeedbackEffect from './feedback/FeedbackEffect';
import actions from '../../actions';
import PopupTitle from "./PopupTitle";
import Warning from "../../assets/img/icons/warning.svg";
import {checkRead} from '../../helpers/feedbackHelpers';


const { updateMyState } = actions.gameStateInput;
const { updateRead } = actions.feedback;

class TaxItem extends Component {
  static propTypes = {
    onChange: PropTypes.func,
    title: PropTypes.string,
    notification: PropTypes.shape({}),
    icon: PropTypes.any,
    globas: PropTypes.any,
    points: PropTypes.any,
    feedbackData: PropTypes.shape({}),
    dataList: PropTypes.array,
    minValue: PropTypes.number,
    maxValue: PropTypes.number,
    sliderValue: PropTypes.number,
    collaborationValue: PropTypes.array,
    sliderKey: PropTypes.string,
    collaborationKey: PropTypes.string,
    notificationReference: PropTypes.string,
    reverseGlobasPoints: PropTypes.bool,
    saving: PropTypes.bool,
  };
  static defaultProps = {
    onChange: () => {},
    reverseGlobasPoints: true,
    title: 'title',
    icon: '',
    globas: 0,
    points: 0,
    dataList: [],
    minValue: 0,
    maxValue: 999,
    sliderKey: 'slider',
    collaborationKey: 'collaboration',
    feedbackData: {},
    notificationReference: '',
    notification: {},
    saving: false,
  };
  constructor (props) {
    super(props);
    this.state = {
      showDropDown: false,
      capNotification: props.sliderValue > props.cap,
      saving: this.props.saving
    };
    this.onChange = this.onChange.bind(this);
  }

  onChange = (key, value) => {
    const { cap } = this.props;
    let capNotification;
    if (cap !== undefined) {
      if (value <= cap && value > 0) {
        capNotification = false;
      }
      if (value > cap) {
        capNotification = true;
      }
    }
    this.setState({
      capNotification: capNotification,
      sliderValue: value
    });

    this.props.dispatch(updateMyState({ [key]: value }));
  };

  markAsRead = () => {
    if (this.props.notification.reference && !checkRead(this.props.notification, false, 0, false)) {
      if ( this.props.feedback.all[this.props.feedback.currentRound].feedback.find((c) => (c.id === this.props.notification.reference)).economie === null ){
        this.props.dispatch(updateRead(this.props.notification.reference, {read: true, economie: true}));
      } else {
        this.props.dispatch(updateRead(this.props.notification.reference, {read: true, economie: false}));
      }
    }
  };

  renderDetails = data => {
    const { props } = this;
    let dataList = data;
    let colIndex = dataList.findIndex(item => item.title === 'Samenwerking met andere landen' || item.title === __('sim_samenwerkingmetanderelanden'));
    // Sort all groups to correct order
    if (colIndex !== -1 && dataList[colIndex].value.length) {
      let arr = dataList[colIndex].value;
      if (arr[0] && arr[0].props && arr[0].props.src && arr[0].props.src > arr[(arr.length - 1)].props.src) {
        dataList[colIndex].value = dataList[colIndex].value.sort(function(a, b){
          var srcA=a.props.src.toLowerCase(), srcB=b.props.src.toLowerCase();
          if (srcA < srcB)
            return -1;
          if (srcA > srcB)
            return 1;
          return 0;
        });
      }
    }

    return (
      dataList.map((item, topDataIndex) => {
        if(item.hideWhenZero) {
          const val = parseInt(item.value.split(' ')[0], 10);
          if(isNaN(val) || val === 0) return '';
        }

        if (Array.isArray(item.value) && !item.value.length) {
          item.value = '-';
        }

        return (<span key={topDataIndex}>
          {props.feedbackData.topData.length-1 === topDataIndex ? <div className={'border-line'}/> : null}
          <div className={'topdata-container'}>
            <p>{item.title}</p>
            <span>{item.value}</span>
          </div>
        </span>)
      })
    )
  };

  componentWillReceiveProps(props) {
    if (props.sliderValue > props.cap) {
      this.setState({capNotification: true});
    }
    if (this.props.feedbackData.show !== props.feedbackData.show) {
      this.setState({showDropDown: false});
    }
    if(props.saving !== this.state.saving){
      if(props.saving) {
        this.setState({
          saving: props.saving,
          showDropDrown: false,
        })
      } else {
        this.setState({
          saving: props.saving,
        })
      }
    }
  }

  render() {
    const { props, state } = this;
    const { myState } = props.gameStateInput;

    return (
      <span>
        <ListButton
          onClick={() => {
            if (props.feedbackData.show) {
              this.markAsRead();
            }
            if (props.registerShown) {
              props.registerShown();
            }
            this.setState({ showDropDown: !state.showDropDown });
          }}
          feedbackCount={props.notification.read && !checkRead(props.notification, false, 0, false) ? 1 : 0}
          bgColor={'white'}
          title={props.title}
          icon={props.icon}
          reverseGlobasPoints={props.reverseGlobasPoints}
          arrow={true}
          bigArrow={true}
          globas={props.globas}
          points={props.points}
        />

        <div className={'content-container' + (state.showDropDown && !props.feedbackData.show ? ' show' : '')}>
          <div className="content-container-background"/>
          { props.project.difficulty === 'PRO' ?
            <PopupTitle customClass={'popup-heading'} popupId={props.popupId} tag={'h4'}/>
            : null
          }

          {props.dataList.map((item, index) =>
            <div key={index} className={'taxes-data'}>
              <p>{item.title}:</p>
              <li>
                <span title={item.globas}>{item.globas}</span>
                <p title={__('sim_miljard')}>{__('sim_miljard')}</p>
              </li>
            </div>
          )}


          { props.taxDescription ?
            <p className={'description'}>{props.taxDescription}</p>
          : null }

          <div className={'border-line'}/>

          {props.sliderTitles !== undefined ?
            <div className={'slider-titles'}>
              <p>{props.sliderTitles[0]}</p>
              <p>{props.sliderTitles[1]}</p>
            </div>
          : null
          }

          {props.type === 'taxSlider' ?
            <div>
              <p>{__('sim_gekozenbelastingpercentage')} ({props.minValue}-{props.cap}%)</p>
            </div>
            : null
          }

          <BudgetSlider
            role={this.props.user.role}
            customOnChange={this.onChange}
            onAfterChange={this.onAfterChange}
            onChangeKey={props.sliderKey}
            twoValueSlider={props.twoValueSlider}
            value={props.sliderValue}
            min={props.minValue}
            unit={props.unit}
            suffix={props.suffix}
            max={props.maxValue}/>

          <div className={'warning-element content-container taxes-slider-warning ' + (this.state.capNotification ? 'show' : '')}>
            <div className='content-container-background'/>
            <span>
              <img src={Warning} alt="warning"/>
              <p dangerouslySetInnerHTML={{ __html: props.capNotification }}/>
            </span>
          </div>

          <div className={'border-line'}/>


          { this.props.project.difficulty === 'PRO' ?
            <BudgetCollaboration
              value={props.collaborationValue}
              customOnChange={this.onChange}
              onChangeKey={props.collaborationKey}
              title={__('sim_selecteer_samenwerk_landen')+':'}/>
          : null }
        </div>

        { state.showDropDown && props.feedbackData.show ?
          <div className={'feedback-container-taxes'}>
            <div className={'content-container show taxes' + (props.feedbackData.effects.length ? ' hasEffects' : '')}>
              <div className={'content-container-background' + (props.feedbackData.effects.length ? ' hasEffects' : '')}/>
            {this.props.project.difficulty === 'PRO' ? (
              <h4 className="popup-heading"><QuestionButton>{props.title}</QuestionButton></h4>
            ) : (
              <div className="popup-heading laag">
                <h4>{__('sim_gekozen_belasting')}</h4>
                <span title={`${myState.arbeidsBelasting}%`} className="point-holder">{`${myState.arbeidsBelasting}%`}</span>
              </div>
            )}
              {this.renderDetails(props.feedbackData.topData)}
              {props.feedbackData.img ? <FeedbackImage image={props.feedbackData.img} description={props.feedbackData.imgDescription}/> : <div style={{ padding: '5px 0' }} /> }
              <span dangerouslySetInnerHTML={{ __html: props.feedbackData.description }}/>
            </div>
            {
              props.feedbackData.effects.length ?
                <div className={'effects-container feedbackdata-effects taxes'}>
                  <div className={'effects-header'}>
                    {__('sim_belastingkeuze_heeft_effect_op')}
                  </div>
                  {props.feedbackData.effects.map((effect, i) => {
                    return (
                      <FeedbackEffect
                        key={i}
                        minimal={true}
                        ministry={effect.title}
                        ministryIcon={effect.icon}
                        description={'Onderschrift'}
                        unit={effect.contentUnit}
                        points={effect.contentTitle}>
                      </FeedbackEffect>
                    );
                  })}
                  <div className={'effects-message'}>
                    {__('sim_zie_deze_effecten_volgende_spelronden')}
                  </div>
                </div>

                : null
            }
          </div>
          : null }
        </span>
    );
  }
}

export default connect(state => state)(TaxItem);



// WEBPACK FOOTER //
// ./src/components/elements/TaxItem.js